import { createReducer } from '@reduxjs/toolkit';
import {
  IWorkerState,
  IWorkerCountsState,
  IWorkerCreateState,
  IWorkerInvitation,
  IWorkerDetails,
  IWorkerDocumentUpdateStatus,
  IWorkerDeleteQualificationState,
  IWorkerUpdateQualificationState,
  IWorkerSkillAndExperienceUpdate,
  IWorkerStatusUpdateState,
  IMapWorkerQualificationState,
  IWorkerDocumentStatusUpdateState,
  IWorkerViewStatusUpdateState,
  IUpdateWorkerViolationFlagState,
  IRateWorkerState,
  IUpdateWorkerRatingState,
  IUpdateWorkerRatesState,
  IWorkerPreferredTimingsState,
  IWorkerStatisticsState,
  IWorkerShiftHistoryState,
  IWorkerCustomFormSubmissionsState,
  IWorkerRoleDocumentRequirementsBulkState,
  IWorkerBulkUploadState,
} from './types';
import {
  fetchWorkerCounts,
  fetchWorkerList,
  createWorker,
  fetchPendingWorkerrList,
  resentWokreInvitation,
  fetchWorkerDetail,
  updateWorkerPrefrence,
  updateWorkerDocuments,
  deleteWorkerQualification,
  updateWorkerQualification,
  updateWorkerSkillAndExperience,
  updateWorkerStatus,
  mapWorkerQualification,
  updateWorkerDocumentStatus, // <--- Add this import
  markWorkerAsViewed,
  updateWorkerViolationFlag,
  rateWorker,
  updateWorkerRating,
  updateWorkerRates,
  fetchWorkerPreferredTimings,
  fetchWorkerStatistics,
  fetchWorkerShiftHistory,
  fetchWorkerCustomFormSubmissions,
  fetchWorkerRoleDocumentRequirementsBulk,
  bulkUploadWorkers,
  setBulkUploadData,
  updateBulkUploadProgress,
  resetBulkUploadState,
  fetchPastShiftWorkerList,
} from './actions';

// ... (existing initial states)

const initialWorkerDocumentStatusUpdateState: IWorkerDocumentStatusUpdateState = {
  loading: false,
  message: null,
  error: null,
};

export const workerDocumentStatusUpdateReducer = createReducer(initialWorkerDocumentStatusUpdateState, (builder) => {
  builder
    .addCase(updateWorkerDocumentStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    })
    .addCase(updateWorkerDocumentStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(updateWorkerDocumentStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialState: IWorkerState = {
  loading: false,
  list: {
    results: [],
    count: 0,
  },
  error: null,
};

const initialCountsState: IWorkerCountsState = {
  loading: false,
  data: {
    all_workers: 0,
    new_registrations: 0,
    suspended_workers: 0,
    pending_workers: 0,
    approved_workers: 0
  },
  error: null,
};

const initialWorkerDetails: IWorkerDetails = {
  loading: false,
  data: null,
  error: null
}

const initialWorkerCreateState: IWorkerCreateState = {
  loading: false,
  message: null,
  error: null,
}

const initailWorkerInvitation: IWorkerInvitation = {
  loading: false,
  message: null,
  error: null,
}

const initialWorkerDocumentsUpdate: IWorkerDocumentUpdateStatus = {
  loading: false,
  message: null,
  error: null,
}

const initialWorkerSkillAndExperienceUpdate: IWorkerSkillAndExperienceUpdate = {
  loading: false,
  message: null,
  error: null,
}

const initialWorkerViewStatusUpdateState: IWorkerViewStatusUpdateState = {
  loading: false,
  message: null,
  error: null,
}

export const markWorkerAsViewReducer = createReducer(initialWorkerViewStatusUpdateState, (builder) => {
  builder
    .addCase(markWorkerAsViewed.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(markWorkerAsViewed.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "Mark worker view status updated!";
    })
    .addCase(markWorkerAsViewed.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const updateWorkerSkillAndExperienceReducer = createReducer(initialWorkerSkillAndExperienceUpdate, (builder) => {
  builder
    .addCase(updateWorkerSkillAndExperience.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateWorkerSkillAndExperience.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(updateWorkerSkillAndExperience.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const updateWorkerDocumentsRedcuer = createReducer(initialWorkerDocumentsUpdate, (builder) => {
  builder
    .addCase(updateWorkerDocuments.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateWorkerDocuments.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(updateWorkerDocuments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const updateWOrkerPreferenceReducer = createReducer(initialWorkerCreateState, (builder) => {
  builder
    .addCase(updateWorkerPrefrence.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateWorkerPrefrence.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(updateWorkerPrefrence.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const workerDetailReducer = createReducer(initialWorkerDetails, (builder) => {
  builder
    .addCase(fetchWorkerDetail.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchWorkerDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchWorkerDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const workerInvitationReducer = createReducer(initailWorkerInvitation, (builder) => {
  builder
    .addCase(resentWokreInvitation.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(resentWokreInvitation.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(resentWokreInvitation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const pendingWorkerListReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchPendingWorkerrList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchPendingWorkerrList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchPendingWorkerrList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

export const workerReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchWorkerList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchWorkerList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchWorkerList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.list = { results: [], count: 0 };
    });
});

export const pastShiftWorkerListReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchPastShiftWorkerList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchPastShiftWorkerList.fulfilled, (state, action) => {
      state.loading = false;
      state.list = action.payload;
    })
    .addCase(fetchPastShiftWorkerList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.list = { results: [], count: 0 };
    });
});

export const workerCounterReducer = createReducer(initialCountsState, (builder) => {
  builder
    .addCase(fetchWorkerCounts.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchWorkerCounts.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    }).addCase(fetchWorkerCounts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

});

export const workerCreateReducer = createReducer(initialWorkerCreateState, (builder) => {
  builder
    .addCase(createWorker.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(createWorker.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(createWorker.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
})

const initialDeleteWorkerQualificationState: IWorkerDeleteQualificationState = {
  loading: false,
  error: null,
  success: false,
};

export const deleteWorkerQualificationReducer = createReducer(initialDeleteWorkerQualificationState, (builder) => {
  builder
    .addCase(deleteWorkerQualification.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    })
    .addCase(deleteWorkerQualification.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    })
    .addCase(deleteWorkerQualification.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});


const initialUpdateWorkerQualificationState: IWorkerUpdateQualificationState = {
  loading: false,
  error: null,
  success: false,
};

export const updateWorkerQualificationReducer = createReducer(initialUpdateWorkerQualificationState, (builder) => {
  builder
    .addCase(updateWorkerQualification.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    })
    .addCase(updateWorkerQualification.fulfilled, (state) => {
      state.loading = false;
      state.success = true;
    })
    .addCase(updateWorkerQualification.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialWorkerStatusUpdateState: IWorkerStatusUpdateState = {
  loading: false,
  message: null,
  error: null,
};

export const workerStatusUpdateReducer = createReducer(initialWorkerStatusUpdateState, (builder) => {
  builder
    .addCase(updateWorkerStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    })
    .addCase(updateWorkerStatus.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(updateWorkerStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialMapWorkerQualificationState: IMapWorkerQualificationState = {
  loading: false,
  message: null,
  error: null,
};

export const mapWorkerQualificationReducer = createReducer(initialMapWorkerQualificationState, (builder) => {
  builder
    .addCase(mapWorkerQualification.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    })
    .addCase(mapWorkerQualification.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    })
    .addCase(mapWorkerQualification.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialUpdateWorkerViolationFlagState: IUpdateWorkerViolationFlagState = {
  loading: false,
  data: null,
  error: null,
};

export const updateWorkerViolationFlagReducer = createReducer(initialUpdateWorkerViolationFlagState, (builder) => {
  builder
    .addCase(updateWorkerViolationFlag.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateWorkerViolationFlag.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    })
    .addCase(updateWorkerViolationFlag.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
}
);

const initialRateWorkerState: IRateWorkerState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

export const rateWorkerReducer = createReducer(
  initialRateWorkerState,
  (builder) => {
    builder
      .addCase(rateWorker.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.data = null;
      })
      .addCase(rateWorker.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(rateWorker.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.data = null;
      });
  },
);

const initialUpdateWorkerRatingState: IUpdateWorkerRatingState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const updateWorkerRatingReducer = createReducer(
  initialUpdateWorkerRatingState,
  (builder) => {
    builder
      .addCase(updateWorkerRating.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = null;
      })
      .addCase(updateWorkerRating.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
        state.error = null;
      })
      .addCase(updateWorkerRating.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
        state.message = null;
      });
  },
);

const initialUpdateWorkerRatesState: IUpdateWorkerRatesState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

export const updateWorkerRatesReducer = createReducer(
  initialUpdateWorkerRatesState,
  (builder) => {
    builder
      .addCase(updateWorkerRates.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateWorkerRates.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(updateWorkerRates.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
);

const initialWorkerPreferredTimingsState: IWorkerPreferredTimingsState = {
  loading: false,
  success: false,
  error: null,
  data: null,
};

export const fetchWorkerPreferredTimingsReducer = createReducer(
  initialWorkerPreferredTimingsState,
  (builder) => {
    builder
      .addCase(fetchWorkerPreferredTimings.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fetchWorkerPreferredTimings.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchWorkerPreferredTimings.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload as string;
      });
  },
);

const initialWorkerStatisticsState: IWorkerStatisticsState = {
  loading: false,
  data: null,
  error: null,
};

export const workerStatisticsReducer = createReducer(
  initialWorkerStatisticsState,
  (builder) => {
    builder
      .addCase(fetchWorkerStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchWorkerStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);


const initialWorkerShiftHistoryState: IWorkerShiftHistoryState = {
  loading: false,
  data: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  count: 0,
  error: null,
};

export const workerShiftHistoryReducer = createReducer(
  initialWorkerShiftHistoryState,
  (builder) => {
    builder
      .addCase(fetchWorkerShiftHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerShiftHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.count = action.payload.count;
        state.error = null;
      })
      .addCase(fetchWorkerShiftHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);

const initialWorkerCustomFormSubmissionsState: IWorkerCustomFormSubmissionsState = {
  loading: false,
  data: [],
  error: null,
};

export const workerCustomFormSubmissionsReducer = createReducer(
  initialWorkerCustomFormSubmissionsState,
  (builder) => {
    builder
      .addCase(fetchWorkerCustomFormSubmissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerCustomFormSubmissions.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchWorkerCustomFormSubmissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);



const initialWorkerRoleDocumentRequirementsBulkState: IWorkerRoleDocumentRequirementsBulkState = {
  loading: false,
  data: [],
  error: null,
};

export const workerRoleDocumentRequirementsBulkReducer = createReducer(
  initialWorkerRoleDocumentRequirementsBulkState,
  (builder) => {
    builder
      .addCase(fetchWorkerRoleDocumentRequirementsBulk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkerRoleDocumentRequirementsBulk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchWorkerRoleDocumentRequirementsBulk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
);
const initialWorkerBulkUploadState: IWorkerBulkUploadState = {
  loading: false,
  data: null,
  error: null,
};

export const workerBulkUploadReducer = createReducer(
  initialWorkerBulkUploadState,
  (builder) => {
    builder
      .addCase(bulkUploadWorkers.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(bulkUploadWorkers.fulfilled, (state) => {
        state.loading = false;
        // Data will be filled via WebSocket
      })
      .addCase(bulkUploadWorkers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(setBulkUploadData, (state, action) => {
        state.data = action.payload;
      })
      .addCase(updateBulkUploadProgress, (state, action) => {
        if (!state.data) {
          state.data = {
            message: 'Processing...',
            summary: action.payload.summary,
            details: [action.payload.detail]
          };
        } else {
          state.data.summary = action.payload.summary;
          const detailIndex = state.data.details.findIndex(d => d.row === action.payload.detail.row);
          if (detailIndex !== -1) {
            // Update existing row
            state.data.details[detailIndex] = action.payload.detail;
          } else {
            // Add new row (prepend for better visibility of latest active row)
            state.data.details = [action.payload.detail, ...state.data.details];
          }
        }
      })

      .addCase(resetBulkUploadState, (state) => {
        state.data = null;
        state.loading = false;
        state.error = null;
      });
  },
);
